import { Injectable } from '@angular/core';
import { ServiceBase } from 'app/shared/serviceBase';
import { AuthenticationService } from 'app/shared/services/authentication-service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LendersModel } from '../models/lenders.model';
import { LenderUserModel } from '../models/lender-user.model';
import { LenderContactModel } from '../models/lender-contact.model';
import { CompanyListModel } from '../../company/models/company-list.model';
import { CompanyUserListModel } from '../../company/models/company-user-list-model';
import { CompanyAuditModuleViewModel } from '../../company-audit/models/company-audit-module-view.model';

@Injectable()
export class LendersService extends ServiceBase {
    private commonUrl: string = this.url + '/Lenders/';
    constructor(
        private _http: HttpClient,
        private _authentication: AuthenticationService
    ) {
        super();
    }

    getAll(): Observable<LendersModel[]> {
        const completeUrl: string = this.commonUrl;
        return this._http
            .get<LendersModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    get(id: string): Observable<LendersModel> {
        const completeUrl: string = this.commonUrl + id;
        return this._http
            .get<LendersModel>(completeUrl).pipe(
                catchError(this.handleError));
    }

    create(model: LendersModel): Observable<string> {
        const completeUrl: string = this.commonUrl;
        return this._http
            .post<string>(completeUrl, model).pipe(
                catchError(this.handleError));
    }

    update(model: LendersModel): Observable<string> {
        const completeUrl: string = this.commonUrl;
        return this._http
            .put<string>(completeUrl, model).pipe(
                catchError(this.handleError));
    }

    delete(id: string): Observable<Response> {
        const completeUrl: string = this.commonUrl + id;
        return this._http.delete(completeUrl).pipe(
            map((response: Response) => response),
            catchError(this.handleError));
    }

    getContacts(id: string): Observable<LenderUserModel[]> {
        const completeUrl: string = this.commonUrl + 'contacts/' + id;
        return this._http
            .get<LenderUserModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    addContact(newContact: LenderContactModel): Observable<string> {
        const completeUrl: string = this.commonUrl + 'contact';
        return this._http.post<string>(completeUrl, newContact).pipe(
            catchError(this.handleError));
    }

    updateContact(newContact: LenderUserModel): Observable<string> {
        const completeUrl: string = this.commonUrl + 'contact';
        return this._http.put<string>(completeUrl, newContact).pipe(
            catchError(this.handleError));
    }

    deleteContact(id: string): Observable<Response> {
        const completeUrl: string = this.commonUrl +'lender-contact/'+ id;
        return this._http.delete(completeUrl).pipe(
            map((response: Response) => response),
            catchError(this.handleError));
    }

    getLenderForContact(id: string): Observable<LendersModel> {
        const completeUrl: string = this.commonUrl + 'lender-for-contact/' + id;
        return this._http
            .get<LendersModel>(completeUrl).pipe(
                catchError(this.handleError));
    }

    getAllowedCompanies(id: string): Observable <CompanyListModel[]> {
        const completeUrl: string = this.commonUrl + 'companies-allowed/' + id;
        return this._http
            .get<CompanyListModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }

    getUsersForLender(lenderId: string, companyId: string): Observable<CompanyUserListModel[]> {
        const completeUrl: string = this.commonUrl + 'lender-company-users/' + lenderId + '/' + companyId;
        return this._http.get<CompanyUserListModel[]>(completeUrl).pipe(
            catchError(this.handleError));
    }

    getAuditModules(lenderId: string, companyId: string, userId: string): Observable<CompanyAuditModuleViewModel[]> {
        const completeUrl: string = this.commonUrl + 'audit-modules-for-user/' + lenderId + '/' + companyId + '/' + userId;
        return this._http
            .get<CompanyAuditModuleViewModel[]>(completeUrl)
            .pipe(catchError(this.handleError));
    }
}
